module.exports = __webpack_public_path__ + "img/session-organic-form-blue-two.10e7f349.svg";